import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import * as accountService from "data/server_apis/accountService";

const initialState = {
  loadingActivate: false,
  errorActivate: false,
  successActivate: false,
  loadingCreate: false,
  errorCreate: false,
  errorMessageCreate: null,
  successCreate: false,
  loadingList: false,
  errorList: false,
  errorMessageList: null,
  successList: false,
  loadingPassChange: false,
  successPassChange: null,
  errorPassChange: null,
  admins: [],
  customers: [],
  distributors: [],
  fillingPersons: [],
  machineAdmins: [],
  locationAdmins: [],
};

export const changePasswordThunk = createAsyncThunk(
  "accounts/changePassword",
  async (data, { rejectWithValue }) => {
    try {
      const response = (await accountService.changePassword(data)).data;
      return response;
    } catch (err) {
      console.log(err);
      const customError = {
        name: err.response?.status,
        message: err.response?.status === 400 ? err.response?.data : null,
      };
      // console.log("Error", customError);
      return rejectWithValue(customError);
    }
  }
);

export const activateAccountThunk = createAsyncThunk(
  "accounts/activateAccount",
  async (id, { rejectWithValue }) => {
    try {
      const response = (await accountService.activateUser(id)).data;
      return response;
    } catch (err) {
      console.log(err);
      const customError = {
        name: err.response?.status,
        message: err.response?.status === 400 ? err.response?.data : null,
      };
      // console.log("Error", customError);
      return rejectWithValue(customError);
    }
  }
);

export const deActivateAccountThunk = createAsyncThunk(
  "accounts/deActivateAccount",
  async (id, { rejectWithValue }) => {
    try {
      const response = (await accountService.deActivateUser(id)).data;
      return response;
    } catch (err) {
      console.log(err);
      const customError = {
        name: err.response?.status,
        message: err.response?.status === 400 ? err.response?.data : null,
      };
      // console.log("Error", customError);
      return rejectWithValue(customError);
    }
  }
);

export const createAdminThunk = createAsyncThunk(
  "accounts/createAdmin",
  async (data, { rejectWithValue }) => {
    try {
      const response = (await accountService.createAdmin(data)).data;
      return response;
    } catch (err) {
      console.log(err);
      const customError = {
        name: err.response?.status,
        message: err.response?.status === 400 ? err.response?.data : null,
      };
      // console.log("Error", customError);
      return rejectWithValue(customError);
    }
  }
);

export const createCustomerThunk = createAsyncThunk(
  "accounts/createCustomer",
  async (data, { rejectWithValue }) => {
    try {
      const response = (await accountService.createCustomer(data)).data;
      console.log(response);
      return response;
    } catch (err) {
      const customError = {
        name: err.response?.status,
        message: err.response?.status === 400 ? err.response?.data : null,
      };
      // console.log("Error", customError);
      return rejectWithValue(customError);
    }
  }
);



export const createDistributorThunk = createAsyncThunk(
  "accounts/createDistributor",
  async (data, { rejectWithValue }) => {
    try {
      const response = (await accountService.createDistributor(data)).data;
      console.log(response);
      return response;
    } catch (err) {
      const customError = {
        name: err.response?.status,
        message: err.response?.status === 400 ? err.response?.data : null,
      };
      // console.log("Error", customError);
      return rejectWithValue(customError);
    }
  }
);

export const createFillingPersonThunk = createAsyncThunk(
  "accounts/createFillingPerson",
  async (data, { rejectWithValue }) => {
    try {
      const response = (await accountService.createFillingPerson(data)).data;
      console.log(response);
      return response;
    } catch (err) {
      const customError = {
        name: err.response?.status,
        message: err.response?.status === 400 ? err.response?.data : null,
      };
      // console.log("Error", customError);
      return rejectWithValue(customError);
    }
  }
);

export const createMachineAdminThunk = createAsyncThunk(
  "accounts/createMachineAdmin ",
  async (data, { rejectWithValue }) => {
    try {
      const response = (await accountService.createMachineAdmin(data)).data;
      console.log(response);
      return response;
    } catch (err) {
      const customError = {
        name: err.response?.status,
        message: err.response?.status === 400 ? err.response?.data : null,
      };
      // console.log("Error", customError);
      return rejectWithValue(customError);
    }
  }
);

export const createLocationAdminThunk = createAsyncThunk(
  "accounts/createLocationAdmin ",
  async (data, { rejectWithValue }) => {
    try {
      const response = (await accountService.createLocationAdmin(data)).data;
      console.log(response);
      return response;
    } catch (err) {
      const customError = {
        name: err.response?.status,
        message: err.response?.status === 400 ? err.response?.data : null,
      };
      // console.log("Error", customError);
      return rejectWithValue(customError);
    }
  }
);

export const createVendingMachineThunk = createAsyncThunk(
  "accounts/createVendingMachine",
  async (data, { rejectWithValue }) => {
    try {
      const response = (await accountService.createVendingMachine(data)).data;
      console.log(response);
      return response;
    } catch (err) {
      const customError = {
        name: err.response?.status,
        message: err.response?.status === 400 ? err.response?.data : null,
      };
      // console.log("Error", customError);
      return rejectWithValue(customError);
    }
  }
);

export const getAdminThunk = createAsyncThunk(
  "accounts/getAdmin",
  async (_, { rejectWithValue }) => {
    try {
      const response = (await accountService.getAdmin()).data;
      console.log(response);
      return response;
    } catch (err) {
      const customError = {
        name: err.response?.status,
        message: err.response?.status === 400 ? err.response?.data : null,
      };
      return rejectWithValue(customError);
    }
  }
);

export const getCustomerThunk = createAsyncThunk(
  "accounts/getCustomer",
  async (_, { rejectWithValue }) => {
    try {
      const response = (await accountService.getCustomer()).data;
      console.log(response);
      return response;
    } catch (err) {
      const customError = {
        name: err.response?.status,
        message: err.response?.status === 400 ? err.response?.data : null,
      };
      return rejectWithValue(customError);
    }
  }
);

export const getDistributorThunk = createAsyncThunk(
  "accounts/getDistributor",
  async (_, { rejectWithValue }) => {
    try {
      const response = (await accountService.getDistributor()).data;
      console.log(response);
      return response;
    } catch (err) {
      const customError = {
        name: err.response?.status,
        message: err.response?.status === 400 ? err.response?.data : null,
      };
      return rejectWithValue(customError);
    }
  }
);

export const getFillingPersonThunk = createAsyncThunk(
  "accounts/getFillingPerson",
  async (_, { rejectWithValue }) => {
    try {
      const response = (await accountService.getFillingPerson()).data;
      console.log(response);
      return response;
    } catch (err) {
      const customError = {
        name: err.response?.status,
        message: err.response?.status === 400 ? err.response?.data : null,
      };
      return rejectWithValue(customError);
    }
  }
);

export const getMachineAdminThunk = createAsyncThunk(
  "accounts/getMachineAdmin ",
  async (_, { rejectWithValue }) => {
    try {
      const response = (await accountService.getMachineAdmin()).data;
      return response;
    } catch (err) {
      const customError = {
        name: err.response?.status,
        message: err.response?.status === 400 ? err.response?.data : null,
      };
      return rejectWithValue(customError);
    }
  }
);

export const getLocationAdminThunk = createAsyncThunk(
  "accounts/getLocationAdmin ",
  async (_, { rejectWithValue }) => {
    try {
      const response = (await accountService.getLocationAdmin()).data;
      return response;
    } catch (err) {
      const customError = {
        name: err.response?.status,
        message: err.response?.status === 400 ? err.response?.data : null,
      };
      return rejectWithValue(customError);
    }
  }
);

const accounts = createSlice({
  name: "accounts",
  initialState,
  reducers: {
    clearState(state, action) {
      state.loadingCreate = false;
      state.errorCreate = false;
      state.successCreate = false;
      state.errorMessageCreate = null;
      state.loadingActivate = false;
      state.successActivate = false;
      state.errorActivate = false;
    },
  },
  extraReducers: {
    // Change pass

    [changePasswordThunk.pending]: (state, action) => {
      state.loadingPassChange = true;
      state.errorPassChange = null;
      state.successPassChange = null;
    },
    [changePasswordThunk.fulfilled]: (state, action) => {
      state.loadingPassChange = false;
      state.errorPassChange = null;
      state.successPassChange = action.payload;
    },
    [changePasswordThunk.rejected]: (state, action) => {
      state.loadingPassChange = false;
      state.errorPassChange = action.payload?.message;
      state.successPassChange = null;
    },

    // Admin
    [createAdminThunk.pending]: (state, action) => {
      state.loadingCreate = true;
      state.errorCreate = false;
      state.successCreate = false;
      state.errorMessageCreate = null;
    },
    [createAdminThunk.fulfilled]: (state, action) => {
      state.loadingCreate = false;
      state.errorCreate = false;
      state.errorMessageCreate = null;
      state.successCreate = true;
      state.admins = [...state.admins, action.payload];
    },
    [createAdminThunk.rejected]: (state, action) => {
      state.loadingCreate = false;
      state.errorMessageCreate = action.payload?.message;
      state.errorCreate = true;
      state.successCreate = false;
    },

    [getAdminThunk.pending]: (state, action) => {
      state.loadingList = true;
      state.errorList = false;
      state.successList = false;
      state.errorMessage = null;
    },
    [getAdminThunk.fulfilled]: (state, action) => {
      state.loadingList = false;
      state.errorList = false;
      state.errorMessageCreate = null;
      state.successList = true;
      state.admins = action.payload;
    },
    [getAdminThunk.rejected]: (state, action) => {
      state.loadingList = false;
      state.errorMessageCreate = action.payload?.message;
      state.errorCreate = true;
      state.successList = false;
    },

    // Distributor
    [createDistributorThunk.pending]: (state, action) => {
      state.loadingCreate = true;
      state.errorCreate = false;
      state.successCreate = false;
      state.errorMessageCreate = null;
    },
    [createDistributorThunk.fulfilled]: (state, action) => {
      state.loadingCreate = false;
      state.errorCreate = false;
      state.errorMessageCreate = null;
      state.successCreate = true;
      state.distributors = [...state.distributors, action.payload];
    },
    [createDistributorThunk.rejected]: (state, action) => {
      console.log(action, action);
      state.loadingCreate = false;
      state.errorMessageCreate = action.payload?.message;
      state.errorCreate = true;
      state.successCreate = false;
    },

    [getDistributorThunk.pending]: (state, action) => {
      state.loadingList = true;
      state.errorList = false;
      state.successList = false;
      state.errorMessage = null;
    },
    [getDistributorThunk.fulfilled]: (state, action) => {
      state.loadingList = false;
      state.errorList = false;
      state.errorMessageCreate = null;
      state.successList = true;
      state.distributors = action.payload;
    },
    [getDistributorThunk.rejected]: (state, action) => {
      state.loadingCreate = false;
      state.errorMessageCreate = action.payload?.message;
      state.errorCreate = true;
      state.successList = false;
    },
    // Filling persons
    [createFillingPersonThunk.pending]: (state, action) => {
      state.loadingCreate = true;
      state.errorCreate = false;
      state.successCreate = false;
      state.errorMessageCreate = null;
    },
    [createFillingPersonThunk.fulfilled]: (state, action) => {
      state.loadingCreate = false;
      state.errorCreate = false;
      state.errorMessageCreate = null;
      state.successCreate = true;
      state.fillingPersons = [...state.fillingPersons, action.payload];
    },
    [createFillingPersonThunk.rejected]: (state, action) => {
      console.log(action, action);
      state.loadingCreate = false;
      state.errorMessageCreate = action.payload?.message;
      state.errorCreate = true;
      state.successCreate = false;
    },

    [getFillingPersonThunk.pending]: (state, action) => {
      state.loadingList = true;
      state.errorList = false;
      state.successList = false;
      state.errorMessage = null;
    },
    [getFillingPersonThunk.fulfilled]: (state, action) => {
      state.loadingList = false;
      state.errorList = false;
      state.errorMessageCreate = null;
      state.successList = true;
      state.fillingPersons = action.payload;
    },
    [getFillingPersonThunk.rejected]: (state, action) => {
      state.loadingCreate = false;
      state.errorMessageCreate = action.payload?.message;
      state.successList = true;
      state.successCreate = false;
    },

    // Machine Admin

    [createMachineAdminThunk.pending]: (state, action) => {
      state.loadingCreate = true;
      state.errorCreate = false;
      state.successCreate = false;
      state.errorMessageCreate = null;
    },
    [createMachineAdminThunk.fulfilled]: (state, action) => {
      state.loadingCreate = false;
      state.errorCreate = false;
      state.errorMessageCreate = null;
      state.successCreate = true;
      state.machineAdmins = [...state.machineAdmins, action.payload];
    },
    [createMachineAdminThunk.rejected]: (state, action) => {
      console.log(action, action);
      state.loadingCreate = false;
      state.errorMessageCreate = action.payload?.message;
      state.errorCreate = true;
      state.successCreate = false;
    },

    [getMachineAdminThunk.pending]: (state, action) => {
      state.loadingList = true;
      state.errorList = false;
      state.successList = false;
      state.errorMessage = null;
    },
    [getMachineAdminThunk.fulfilled]: (state, action) => {
      state.loadingList = false;
      state.errorList = false;
      state.errorMessageCreate = null;
      state.successList = true;
      state.machineAdmins = action.payload;
    },
    [getMachineAdminThunk.rejected]: (state, action) => {
      state.loadingCreate = false;
      state.errorMessageCreate = action.payload?.message;
      state.errorCreate = true;
      state.successList = false;
    },

    // Location Admin

    [createLocationAdminThunk.pending]: (state, action) => {
      state.loadingCreate = true;
      state.errorCreate = false;
      state.successCreate = false;
      state.errorMessageCreate = null;
    },
    [createLocationAdminThunk.fulfilled]: (state, action) => {
      state.loadingCreate = false;
      state.errorCreate = false;
      state.errorMessageCreate = null;
      state.successCreate = true;
      state.locationAdmins = [...state.locationAdmins, action.payload];
    },
    [createLocationAdminThunk.rejected]: (state, action) => {
      console.log(action, action);
      state.loadingCreate = false;
      state.errorMessageCreate = action.payload?.message;
      state.errorCreate = true;
      state.successCreate = false;
    },

    [getLocationAdminThunk.pending]: (state, action) => {
      state.loadingList = true;
      state.errorList = false;
      state.successList = false;
      state.errorMessage = null;
    },
    [getLocationAdminThunk.fulfilled]: (state, action) => {
      state.loadingList = false;
      state.errorList = false;
      state.errorMessageCreate = null;
      state.successList = true;
      state.locationAdmins = action.payload;
    },
    [getLocationAdminThunk.rejected]: (state, action) => {
      state.loadingCreate = false;
      state.errorMessageCreate = action.payload?.message;
      state.errorCreate = true;
      state.successList = false;
    },

    // Customer

    // [createCustomerProfileThunk.pending]: (state, action) => {
    //   state.loadingCreate = true;
    //   state.errorCreate = false;
    //   state.successCreate = false;
    //   state.errorMessageCreate = null;
    // },
    // [createCustomerProfileThunk.fulfilled]: (state, action) => {
    //   state.loadingCreate = false;
    //   state.errorCreate = false;
    //   state.errorMessageCreate = null;
    //   state.successCreate = true;
    //   state.customers = [...state.customers, action.payload];
    // },
    // [createCustomerProfileThunk.rejected]: (state, action) => {
    //   console.log(action, action);
    //   state.loadingCreate = false;
    //   state.errorMessageCreate = action.payload?.message;
    //   state.errorCreate = true;
    //   state.successCreate = false;
    // },

    [getCustomerThunk.pending]: (state, action) => {
      state.loadingList = true;
      state.errorList = false;
      state.successList = false;
      state.errorMessage = null;
    },
    [getCustomerThunk.fulfilled]: (state, action) => {
      state.loadingList = false;
      state.errorList = false;
      state.errorMessageCreate = null;
      state.successList = true;
      state.customers = action.payload;
    },
    [getCustomerThunk.rejected]: (state, action) => {
      state.loadingCreate = false;
      state.errorMessageCreate = action.payload?.message;
      state.errorCreate = true;
      state.successList = false;
    },

    // Activate user

    [activateAccountThunk.pending]: (state, action) => {
      state.loadingActivate = true;
      state.errorActivate = false;
      state.successActivate = false;
    },
    [activateAccountThunk.fulfilled]: (state, action) => {
      state.loadingActivate = false;
      state.errorActivate = false;
      state.successActivate = true;
      switch (action.payload.role) {
        case "distributor":
          state.distributors = state.distributors.map((distributor) =>
            distributor.id === action.payload.id ? action.payload : distributor
          );
          break;
        case "admin":
          state.admins = state.admins.map((admin) =>
            admin.id === action.payload.id ? action.payload : admin
          );
          break;
        case "filling_person":
          state.fillingPersons = state.fillingPersons.map((fillingPerson) =>
            fillingPerson.id === action.payload.id
              ? action.payload
              : fillingPerson
          );
          break;
        case "machine_admin":
          state.machineAdmins = state.machineAdmins.map((machineAdmin) =>
            machineAdmin.id === action.payload.id
              ? action.payload
              : machineAdmin
          );
          break;
        case "customer":
          state.customers = state.customers.map((customer) =>
            customer.id === action.payload.id ? action.payload : customer
          );
          break;
        default:
          break;
      }
    },
    [activateAccountThunk.rejected]: (state, action) => {
      state.loadingActivate = false;
      state.errorActivate = true;
      state.successActivate = false;
    },

    [deActivateAccountThunk.pending]: (state, action) => {
      state.loadingActivate = true;
      state.errorActivate = false;
      state.successActivate = false;
    },
    [deActivateAccountThunk.fulfilled]: (state, action) => {
      state.loadingActivate = false;
      state.errorActivate = false;
      state.successActivate = true;
      switch (action.payload.role) {
        case "distributor":
          console.log("in distributor " + action.payload.id);
          state.distributors = state.distributors.map((distributor) =>
            distributor.id === action.payload.id ? action.payload : distributor
          );
          break;
        case "admin":
          state.admins = state.admins.map((admin) =>
            admin.id === action.payload.id ? action.payload : admin
          );
          break;
        case "filling_person":
          state.fillingPersons = state.fillingPersons.map((fillingPerson) =>
            fillingPerson.id === action.payload.id
              ? action.payload
              : fillingPerson
          );
          break;
        case "machine_admin":
          state.machineAdmins = state.machineAdmins.map((machineAdmin) =>
            machineAdmin.id === action.payload.id
              ? action.payload
              : machineAdmin
          );
          break;
        case "customer":
          state.customers = state.customers.map((customer) =>
            customer.id === action.payload.id ? action.payload : customer
          );
          break;
        default:
          break;
      }
    },
    [deActivateAccountThunk.rejected]: (state, action) => {
      state.loadingActivate = false;
      state.errorActivate = true;
      state.successActivate = false;
    },
  },
});
export const { clearState } = accounts.actions;
export default accounts.reducer;
